module.exports = __webpack_public_path__ + "src/app/assets/images/moduleselection/img2.svg";